class CartCrossSell extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.checkbox.addEventListener('change', this.onChange.bind(this));
  }

  onChange(event) {
    event.stopPropagation();
    const checked = event.target.checked;
    const variantId = this.checkbox.dataset.variantId;
    this.classList.add('loading');

    const sections = ['cart-drawer', 'cart-icon-bubble', 'cart-icon-bubble--mobile', 'cart-free-delivery'];
    const sections_url = window.location.pathname;

    const request = checked
      ? fetch(routes.cart_add_url, {
          ...fetchConfig(),
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections,
            sections_url,
          }),
        })
      : fetch(routes.cart_change_url, {
          ...fetchConfig(),
          body: JSON.stringify({ id: variantId, quantity: 0, sections, sections_url }),
        });

    request
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          throw new Error(parsedState.description || 'Cart error');
        }
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.renderContents(parsedState);
      })
      .catch(() => {
        event.target.checked = !checked;
        this.classList.remove('loading');
      });
  }
}

customElements.define('cart-cross-sell', CartCrossSell);
